<template>
    <v-card elevation="3" min-width="540px">
        <v-card-title>
            <router-link class="d-flex justify-center align-center text-decoration-none" to="/">
                <div class="text-black d-flex flex-column align-center">
                    <v-img :src="logo" :width="75" draggable="false"/>
                    <v-img :src="logoText" :width="100" draggable="false"/>
                </div>
            </router-link>
        </v-card-title>
        <v-card-title>Verify your email</v-card-title>
        <v-card-text>
            Enter the 6-digit code sent to your email address

            <v-form ref="form" v-model="formData.valid" validate-on="input lazy">
                <v-text-field
                    v-model="formData.code"
                    label="6-digit code"
                    inputmode="numeric"
                    maxlength="6"
                    :rules="codeRules"
                    @input="onCodeInput"
                />

                <v-btn :disabled="!formData.valid" block color="primary" @click="submit">Verify</v-btn>
            </v-form>
        </v-card-text>
    </v-card>
</template>

<script setup>
import router from "@/router";
import {onMounted, reactive} from 'vue'
import {send} from "@/composables/apiClient";
import {showApiError} from "@/composables/useApiError";
import logo from "@/assets/images/logo-1.png";
import logoText from "@/assets/images/logo-text.png";
import {useNavigation} from "@/composables/globals";
import {useSnackbarStore} from "@/stores/snackBarStore";

const snackbar = useSnackbarStore()
const {navigateTo} = useNavigation()
const formData = reactive({
    code: null,
    valid: false,
})

const codeRules = [
    v => !!v || 'Enter the code we emailed you',
    v => /^\d{6}$/.test(v || '') || 'Enter the 6-digit numeric code',
]

// Strip anything non-numeric as the user types so paste-from-email
// with stray whitespace or letters still works.
const onCodeInput = () => {
    if (formData.code) {
        formData.code = formData.code.replace(/\D/g, '').slice(0, 6)
    }
}

const submit = () => {
    send('put', `verify-user/${router.currentRoute.value.params.id}`, formData)
        .then((response) => {
            snackbar.showSnackbar(response.data.message)
            navigateTo('login')
        })
        .catch((error) => showApiError(snackbar, error, 'Incorrect code. Please try again.'))
}

onMounted(() => {
    send('post', `send-verification/${router.currentRoute.value.params.id}/mail`, null)
        .catch(function (errorResponse) {
            // Initial auto-send on page mount - silently swallow throttle
            // errors so the user isn't greeted with an error on landing;
            // they can always click Resend. Surface non-throttle errors
            // since they indicate a real problem (network/server).
            if (errorResponse?.response?.status !== 429) {
                showApiError(snackbar, errorResponse, "Couldn't send the code. Please use Resend.");
            }
        })
})
</script>

<style scoped>

</style>
